import { devices } from '@src/styles/theme';
import { useRouter } from 'next/router';
import React from 'react';
import styled from 'styled-components';

/**
 * 헌혈요청 목록 빈 상태 (Pple Blood Request List 디자인 이식).
 *
 * '알림 받기'는 조건 구독 API가 없어 알림 설정 화면으로 보낸다.
 */
type Props = {
  onReset: () => void;
};

const DonationEmpty = ({ onReset }: Props) => {
  const router = useRouter();
  return (
    <Card>
      <IconCircle>
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
          <circle
            cx="11"
            cy="11"
            r="7"
            stroke="#FF6969"
            strokeWidth="1.8"
          />
          <path
            d="M16.2 16.2 L21 21"
            stroke="#FF6969"
            strokeWidth="1.8"
            strokeLinecap="round"
          />
        </svg>
      </IconCircle>
      <Title>조건에 맞는 요청이 없어요</Title>
      <Text>
        필터를 넓히면 다른 지역의 요청도 볼 수 있어요.
        <br />
        알림을 켜두면 조건에 맞는 요청이 올라올 때 바로 알려드려요.
      </Text>
      <Buttons>
        <PrimaryButton onClick={onReset}>필터 초기화</PrimaryButton>
        <SecondaryButton onClick={() => router.push('/my')}>
          알림 받기
        </SecondaryButton>
      </Buttons>
    </Card>
  );
};

const Card = styled.div`
  background: #ffffff;
  border: 1px solid #ededed;
  border-radius: 20px;
  padding: 72px 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  @media ${devices.tablet} {
    padding: 48px 20px;
    border-radius: 16px;
  }
`;
const IconCircle = styled.div`
  width: 88px;
  height: 88px;
  border-radius: 44px;
  background: #fff1ed;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const Title = styled.h3`
  margin: 0;
  font-family: 'Var', sans-serif;
  font-size: 19px;
  font-weight: 700;
  color: #222222;
`;
const Text = styled.p`
  margin: 0;
  font-size: 14px;
  line-height: 22px;
  color: #767676;
  text-align: center;
`;
const Buttons = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: center;
`;
const PrimaryButton = styled.button`
  height: 44px;
  padding: 0 22px;
  border: none;
  border-radius: 22px;
  background: #ff4651;
  color: #ffffff;
  font-size: 14.5px;
  font-weight: 700;
  cursor: pointer;
  &:hover {
    background: #e03a44;
  }
`;
const SecondaryButton = styled(PrimaryButton)`
  border: 1px solid #ff4651;
  background: #fff1ed;
  color: #ff4651;
  &:hover {
    background: #ffe3dc;
  }
`;

export default DonationEmpty;
